/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_Style_5aInputs */

const en_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style 5A`)
};

const fr_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style 5A`)
};

const de_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil 5A`)
};

const it_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile 5A`)
};

const ru_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль 5А`)
};

const es_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo 5A`)
};

const zh_cn2_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`款式 5A`)
};

const ja_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイル5A`)
};

const hi_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैली 5ए`)
};

const pt_pt2_ccsl_export_template_style_5a = /** @type {(inputs: Ccsl_Export_Template_Style_5aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo 5A`)
};

/**
* | output |
* | --- |
* | "Style 5A" |
*
* @param {Ccsl_Export_Template_Style_5aInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_style_5a = /** @type {((inputs?: Ccsl_Export_Template_Style_5aInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_Style_5aInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_style_5a(inputs)
	if (locale === "de") return de_ccsl_export_template_style_5a(inputs)
	if (locale === "it") return it_ccsl_export_template_style_5a(inputs)
	if (locale === "ru") return ru_ccsl_export_template_style_5a(inputs)
	if (locale === "es") return es_ccsl_export_template_style_5a(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_style_5a(inputs)
	if (locale === "ja") return ja_ccsl_export_template_style_5a(inputs)
	if (locale === "hi") return hi_ccsl_export_template_style_5a(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_style_5a(inputs)
	return en_ccsl_export_template_style_5a(inputs)
});